import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={user.role === "podcaster" ? "/publish" : "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { const u = await login(email, password); navigate(u.role === "podcaster" ? "/publish" : "/admin"); }
    catch (err) { setError(errorMessage(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 relative grain" data-testid="login-page">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,#053671_0%,transparent_60%)] opacity-60" />
      <form onSubmit={submit} className="relative w-full max-w-md card-surface rounded-3xl p-8 sm:p-10 reveal">
        <Link to="/" className="flex items-center gap-3 mb-8" data-testid="login-logo-link"><Logo size={48} /><span className="font-display font-extrabold text-xl">Admin Portal</span></Link>
        <h1 className="font-display text-3xl font-black tracking-tight">Welcome back</h1>
        <p className="mt-1 text-sm text-slate-400">Admins manage the network; hosts sign in to publish episodes.</p>
        <div className="mt-8 space-y-4">
          <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 bg-white/5 border-white/10" data-testid="login-email-input" /></div>
          <div><Label htmlFor="password">Password</Label><div className="mt-1.5"><PasswordInput id="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-white/5 border-white/10" testId="login-password-input" /></div></div>
        </div>
        {error && <p className="mt-4 text-sm text-rose-400" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={loading} className="mt-6 w-full rounded-full bg-sky-400 text-[#070F1E] font-bold hover:bg-sky-300" data-testid="login-submit-button">{loading ? "Signing in…" : "Sign in"}</Button>
        <Link to="/forgot-password" className="mt-5 block text-center text-sm text-slate-400 hover:text-white" data-testid="login-forgot-link">Forgot your password?</Link>
      </form>
    </div>
  );
}
